<template>
  <div class="footer-wrapper">
    <div class="footer-content">
      <div class="footer-links">
        <a href="mailto:service@letsssl.com" class="contact-link">
          <i class="el-icon-message"></i> Contact Us - service@letsssl.com
        </a>
      </div>
      <div class="copyright">
        © 2026 Let's SSL. Made with ❤️ for secure web.
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer"
}
</script>

<style lang="scss" scoped>
.footer-wrapper {
  margin-top: auto;
  background: #fff;
  border-top: 1px solid #e4e8ef;
}

.footer-content {
  max-width: 1140px;
  margin: 0 auto;
  padding: 22px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}

.contact-link {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #6b7a90;
  font-size: 14px;
  text-decoration: none;
  transition: color 0.15s ease;

  &:hover {
    color: #409eff;
  }

  i {
    font-size: 15px;
  }
}

.copyright {
  font-size: 13px;
  color: #98a5b8;
  line-height: 1.5;
}

@media screen and (max-width: 768px) {
  .footer-content {
    padding: 18px 14px;
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
  }

  .contact-link {
    font-size: 13px;
  }

  .copyright {
    font-size: 12px;
  }
}
</style>